export default "__VITE_ASSET__GKMbkX9S__"